import { useEffect } from "react";
import useCountDown from "react-countdown-hook";
import { convertMsToRemainingTime } from "helpers/convertFormData";

interface ITimeLeftToBidProps {
  closeTime: number;
}

export default function TimeLeftToBidMobile({ closeTime }: Readonly<ITimeLeftToBidProps>) {
  const [timeLeft, { start: startBidTimer }] = useCountDown(closeTime, 1000);

  useEffect(() => {
    if (closeTime > 0) {
      startBidTimer(closeTime);
    }
  }, [closeTime]);

  return (
    <span className="text-error">
      {closeTime < 0
        ? "Bidding Has Ended"
        : `Time left to bid: ${convertMsToRemainingTime(timeLeft)}`}
    </span>
  );
}
